
import { DxCheckBox } from "devextreme-vue/check-box";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import DxTabPanel, { DxItem as DxTabPanelItem } from "devextreme-vue/tab-panel";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import { Component, Vue } from "vue-property-decorator";
import ClientsGrille from "./components/ClientsGrille.vue";
import IndexGrille from "./components/IndexGrille.vue";
import IndexationSelectionGrille from "./components/IndexationSelectionGrille.vue";
import IndexationSimulationGrille from "./components/IndexationSimulationGrille.vue";
import TarifsGrille from "./components/TarifsGrille.vue";

@Component({
  components: {
    DxToolbar,
    DxItem,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxTabPanel,
    DxTabPanelItem,
    IndexGrille,
    TarifsGrille,
    ClientsGrille,
    IndexationSelectionGrille,
    IndexationSimulationGrille,
    DxCheckBox,
  },
})
export default class IndexationUpdate extends Vue {
  constructor() {
    super();
  }
  popupVisible = true;
  positionOf = "";
  SelectedRowKeys: number[] = [];

  addButtonOptions = {
    icon: "fa-light fa-gear",
    text: "Parametre",
    onClick: () => {
      // si on veux placer le premier tab a l'ouverture de la popup
      // let dxTabPanel = this.$refs.dxTabPanel as DxTabPanel;
      // dxTabPanel?.instance?.option("selectedIndex", 0);
      let dxPopup = this.$refs.dxPopup as DxPopup;
      dxPopup?.instance?.show();
    },
  };
}
